import { get, del } from '../api.service';

export interface DraftInvoiceParams {
  PageNumber: number;
  PageSize: number;
  type?: number;
  status?: number;
  searchQuery?: string;
}
export interface DraftInvoiceItem {
  id: number;
  invoiceNumber: string;
  clientName: string;
  amount: number;
  dueDate: string;
  invoiceStatus: number;
  paymentTerm?: string;
  accountType?: number;
  country?: string;
  stage?: string;
  customer?: {
    name?: string;
    paymentTerm?: string;
    accountType?: number;
    country?: string;
  };
}

export interface DraftInvoiceResponse {
  statusCode: number;
  message: string;
  response: DraftInvoiceItem[];
  totalCount: number;
  numberOfPages: number;
}

/**
 * Fetches draft invoices with pagination and filters.
 * @param params - The request parameters containing PageNumber, PageSize, type (stage), and status.
 * @returns The API response with the paginated draft invoice data.
 */
// export const fetchDraftInvoices = async (params: DraftInvoiceParams): Promise<DraftInvoiceResponse> => {
//   try {
//     const response = await get('/invoicecontrollerv2/all-approval-invoices-v2?', {
//       PageNumber: params.PageNumber,
//       PageSize: params.PageSize,
//     });
//     return response;
//   } catch (error) {
//     console.error('Error fetching draft invoices:', error);
//     throw error;
//   }
// };


export const fetchDraftInvoices = async (
  params: DraftInvoiceParams
): Promise<DraftInvoiceResponse> => {
  try {
    const response = await get('/invoicev2/all-approval-invoices-v2', {
      PageNumber: params.PageNumber,
      PageSize: params.PageSize,
      ...(params.searchQuery && { searchQuery: params.searchQuery }),
    });
    return response;
  } catch (error: any) {
    console.error('Invoice search API error:', error);
    throw new Error(
      error.response?.data?.message ||
        error.message ||
        'Failed to fetch invoices'
    );
  }
};
export const deleteDraft = async (
  preId: number | string
)=> {
  try {
    const response = await del(
      `/invoice/preliminary-invoice-delete/${preId}`
    );

    return response;
  } catch (error: any) {
    console.error('Delete draft API error:', error);

    throw new Error(
      error?.response?.data?.message ||
      error?.message ||
      'Failed to delete draft invoice'
    );
  }
};
